/**
 * Maps `Assessments/Request` list rows to the same shape used by the shared Assessment Request grid
 * (admin payload uses `vqa_request_*`; sponsor/provider lists often use `vqa_*` fields).
 */
export function normalizeVqaListItemForAssessmentGrid(item) {
  if (!item) return item;
  const rawStatus = item.vqa_request_status ?? item.vqa_status;
  return {
    ...item,
    vqa_request_status: rawStatus,
    vqa_request_created_On: item.vqa_request_created_On ?? item.vqa_created_on,
    released_date: item.released_date ?? item.vqa_report_released_on,
  };
}

/**
 * Optional display status for StatusIndicator (legacy sponsor grid collapsed post-delivery states).
 */
export function getVqaListStatusForIndicator(item, { collapseReportStatuses = false } = {}) {
  const s = item?.vqa_request_status ?? item?.vqa_status ?? "";
  if (
    collapseReportStatuses &&
    (s === "Report Anonymized" || s === "Report Published to Library")
  ) {
    return "Final Report Delivered";
  }
  return s;
}
